import React from "react";
import { connect } from 'react-redux';
import Geocode from "react-geocode";
import SweetAlert from "react-bootstrap-sweetalert";


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CircularProgress from '@material-ui/core/CircularProgress';

import Add from "@material-ui/icons/AddBox";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

// style for this view
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import { formatStatus, sanitize } from "../../../utils/helpers";
import { fetchProjectsRequest } from "../../../actions/project";
import { createJobCardReset, craeteJobCardRequest } from "../../../actions/jobCard";
import { TOWNS_LIST } from "../../../utils/enums";

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_KEY);


const initialState = {
  town: '',
  standNumber: null,
  physicalAddress: '',
  subdivision: null,
  extention: null,
  latitude: '',
  logitude: '',
  accountNumber: '',
  venusNumber: '',
  portion: null,
  standErroCode: '',
  contactPerson: '',
  contactPhone: '',
  isHighPriority: false,
  jobInstruction: '',
  notes: '',
  meterType: '',
  meterPaymentType: '',
  error: {},
  projectId: '',
  jobClass: '',
  type: '',
  region: '',
  municipalityRefNumber: '',
  success: false,
  createdJob: null,
  oldMeterNumber: '',
  allowDuplicateJob: false,
};
class CreateJobCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillMount() {
    this.props.dispatch(fetchProjectsRequest());
  }

  componentDidUpdate() {
    if (this.props.jobsData.createSuccess) {
      this.setState({ ...initialState, success: true });
    }

    if (this.props.jobsData.createdJob) {
      this.setState({ ...initialState, createdJob: this.props.jobsData.createdJob });
    }

    if (this.props.jobsData.createdJob) {
      this.props.dispatch(createJobCardReset());
    }

  }


  handleTextChange(field, event) {
    const { value } = event.target;
    let { error } = this.state
    const newError = { ...error, [field]: false }

    const requiredMeterJobTypes = this.props.configsData.configs ?
      this.props.configsData.configs.meterRequiredJobs : [];

    if (field === 'physicalAddress') {
      Geocode.fromAddress(value).then(
        response => {
          const { lat, lng } = response.results[0].geometry.location;
          this.setState({ logitude: lng, latitude: lat });
        },
        error => {
          console.error(error);
        }
      );
    }

    if (field === 'type') {
      if (requiredMeterJobTypes.includes(value)) {
        this.setState({ [field]: value, error: newError, meterRequired: true });
      } else {
        this.setState({ [field]: value, error: newError, meterRequired: false });

      }
    } else {
      this.setState({ [field]: value, error: newError });
    }
  }


  handleVenusGroup(field, size, event) {
    const { value } = event.target;
    let { error } = this.state
    const newError = { ...error, [field]: false }
console.log("field: ", field);

    if (field === 'town') {
      this.setState({ [field]: value }, () => {
        this.buildVenusNumber()
      });
    }
    if (value.length <= size) {
      this.setState({ [field]: value }, () => {
        this.buildVenusNumber()
      });
    }
    else{
      this.setState({ error: newError })
    }

  }

  handleSwitchTogle(field, event) {
    this.setState({ [field]: !this.state[field] });
  }

  toggleAllowDuplicateJob(){
    this.setState({ allowDuplicateJob: !this.state.allowDuplicateJob});
  }

  validateJobCardForm() {
    const requiredMeterJobTypes = this.props.configsData.configs ?
      this.props.configsData.configs.meterRequiredJobs : [];
    let errorFlag = false;
    let newError = this.state.error;
    if (!this.state.town) {
      newError.town = true;
      errorFlag = true;
    }
    if (!this.state.standNumber) {
      newError.standNumber = true;
      errorFlag = true;
    }
    if (!this.state.portion) {
      newError.portion = true;
      errorFlag = true;
    }
    if (!this.state.extention) {
      newError.extention = true;
      errorFlag = true;
    }
    if (!this.state.subdivision) {
      newError.subdivision = true;
      errorFlag = true;
    }

    if (!this.state.physicalAddress) {
      newError.physicalAddress = true;
      errorFlag = true;
    }

    if (!this.state.accountNumber) {
      newError.accountNumber = true;
      errorFlag = true;
    }

    if (!this.state.projectId) {
      newError.projectId = true;
      errorFlag = true;
    }

    if (!this.state.jobClass) {
      newError.jobClass = true;
      errorFlag = true;
    }

    if (!this.state.jobInstruction) {
      newError.jobInstruction = true;
      errorFlag = true;
    }

    if (!this.state.type) {
      newError.type = true;
      errorFlag = true;
    } else if (requiredMeterJobTypes.includes(this.state.type)) {
      if (!this.state.meterType) {
        newError.meterType = true;
        errorFlag = true;
      }
      if (!this.state.meterPaymentType) {
        newError.meterPaymentType = true;
        errorFlag = true;
      }
    }
    this.setState({ error: newError });
    return errorFlag;
  }

  createJobCard() {
    console.log("testing payload", this.validateJobCardForm())
    if (this.validateJobCardForm()) {
      return;
    }

    const standInfo = {
      standNumber: this.state.standNumber,
      town: this.state.town,
      physicalAddress: this.state.physicalAddress,
      subdivision: this.state.subdivision,
      latitude: this.state.latitude,
      longitude: this.state.logitude,
      accountNumber: parseFloat(this.state.accountNumber),
      venusNumber: this.state.venusNumber,
      portion: this.state.portion,
      standErroCode: this.state.standErroCode,
      contactPerson: this.state.contactPerson,
      contactPhone: this.state.contactPhone,
      notes: this.state.notes,
    }

    const meterFilter = {
      meterType: this.state.meterType,
      meterPaymentType: this.state.meterPaymentType,
      condition: this.state.condition,
      meterDialType: this.state.meterDialType,
      tag: this.state.tag,
      brand: this.state.brand,
      model: this.state.model
    }

    let payload;

    if (this.state.meterRequired) {
      payload = {
        type: this.state.type,
        isHighPriority: this.state.isHighPriority,
        projectId: this.state.projectId,
        jobInstruction: this.state.jobInstruction,
        stand: sanitize(standInfo),
        meterFilter: sanitize(meterFilter),
        jobClass: this.state.jobClass,
        region: this.state.region,
        municipalityRefNumber: this.state.municipalityRefNumber,
        oldMeterNumber: this.state.oldMeterNumber,
        allowDuplicateJob: this.state.allowDuplicateJob
      }
    } else {
      payload = {
        type: this.state.type,
        isHighPriority: this.state.isHighPriority,
        projectId: this.state.projectId,
        jobInstruction: this.state.jobInstruction,
        stand: sanitize(standInfo),
        jobClass: this.state.jobClass,
        region: this.state.region,
        municipalityRefNumber: this.state.municipalityRefNumber,
        oldMeterNumber: this.state.oldMeterNumber,
        allowDuplicateJob: this.state.allowDuplicateJob

      }
    }

    console.log("payload", payload);
    this.props.dispatch(craeteJobCardRequest(payload));

  }
  buildVenusNumber() {
    const town = TOWNS_LIST.find(town => town.name === this.state.town) || '000';
    const code = town.code || '000'
    const extention = this.trailZeroes(this.state.extention, 3)
    const standNumber = this.trailZeroes(this.state.standNumber, 8)
    const portion = this.trailZeroes(this.state.portion, 5)
    const subdivision = this.trailZeroes(this.state.subdivision, 4)
    const dummyExtraFields = "0000"
    const venusNumber = code + extention + standNumber + portion + subdivision + dummyExtraFields
    this.setState({ venusNumber })
  }

  trailZeroes(field, size) {
    if (field === null) {
      return "0".repeat(size)
    }
    const zeroes = size - field.length

    if (field.length > size) {
      return null
    }
    if (field.length === size) {
      return field
    }

    return "0".repeat(zeroes) + field
  }

  render() {
    const { classes } = this.props;

    const jobTypes = this.props.configsData.configs ? this.props.configsData.configs.jobTypes : [];
    const meterConditions = this.props.configsData.configs ? this.props.configsData.configs.meterConditions : [];
    const meterTypes = this.props.configsData.configs ? this.props.configsData.configs.meterType : [];
    const meterPaymentTypes = this.props.configsData.configs ? this.props.configsData.configs.meterPaymentType : [];
    const meterDialTypes = this.props.configsData.configs ? this.props.configsData.configs.meterDialType : [];
    const towns = TOWNS_LIST;
    const projects = this.props.projectData.projects || [];
    const successButtonStyle = {
      backgroundColor: "#4CAF50", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }

    const dangerButtonStyle = {
      backgroundColor: "orange", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Stand Information</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={3}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          SELECT TOWN *
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.town}
                          error={this.state.error.town}
                          onChange={this.handleVenusGroup.bind(this, 'town',3)}
                          inputProps={{
                            name: "town",
                            id: "town"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            SELECT TOWN
                        </MenuItem>
                          {
                            towns.map((town, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={town.name}
                              >
                                {town.name}
                              </MenuItem>
                            )
                          }

                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                      error={this.state.error.extention}
                        labelText="Extention"
                        id="extention"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "number",
                          value: this.state.extention,
                          onChange: this.handleVenusGroup.bind(this, 'extention', 3),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.standNumber}
                        labelText="Stand Number *"
                        id="standNumber"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "number",
                          value: this.state.standNumber,
                          onChange: this.handleVenusGroup.bind(this, 'standNumber', 8),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                      error={this.state.error.portion}
                        labelText="Portion"
                        id="portion"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "number",
                          value: this.state.portion,
                          onChange: this.handleVenusGroup.bind(this, 'portion', 5),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.subdivision}
                        labelText="Subdivision"
                        id="subdivision"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "number",
                          value: this.state.subdivision,
                          onChange: this.handleVenusGroup.bind(this, 'subdivision', 4),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Venus No"
                        id="venusNumber"
                        formControlProps={{
                          fullWidth: true,
                          // readOnly
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.venusNumber,

                          // onChange: this.handleTextChange.bind(this, 'venusNumber'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.physicalAddress}
                        labelText=" Address  *"
                        id="physicalAddress"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.physicalAddress,
                          onChange: this.handleTextChange.bind(this, 'physicalAddress'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Latitude"
                        id="latitude"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.latitude,
                          readOnly: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Longitude"
                        id="longitude"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.logitude,
                          readOnly: true,
                        }}
                      />
                    </GridItem>


                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.accountNumber}
                        labelText="Account No *"
                        id="accountNumber"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.accountNumber,
                          onChange: this.handleTextChange.bind(this, 'accountNumber'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Stand Error Code"
                        id="standErroCode"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.standErroCode,
                          onChange: this.handleTextChange.bind(this, 'standErroCode'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Contact Person"
                        id="contactPerson"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.contactPerson,
                          onChange: this.handleTextChange.bind(this, 'contactPerson'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Contact Phone"
                        id="contactPhone"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.contactPhone,
                          onChange: this.handleTextChange.bind(this, 'contactPhone'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Notes"
                        id="notes"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.notes,
                          multiline: true,
                          onChange: this.handleTextChange.bind(this, 'notes'),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>


          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Job Information</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={3}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Choose Job Type*
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.type}
                          error={this.state.error.type}
                          onChange={this.handleTextChange.bind(this, 'type')}
                          inputProps={{
                            name: "type",
                            id: "type"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Job Type
                        </MenuItem>
                          {
                            jobTypes.map((type, index) =>
                              <MenuItem
                                key={index}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={3}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Assign Project*
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.projectId}
                          error={this.state.error.projectId}
                          onChange={this.handleTextChange.bind(this, 'projectId')}
                          inputProps={{
                            name: "projectId",
                            id: "projectId"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Project
                        </MenuItem>
                          {
                            projects.map((project, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={project._id}
                              >
                                {project.name}
                              </MenuItem>
                            )
                          }

                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                      <br />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={!!this.state.meterRequired}
                            classes={{
                              switchBase: classes.switchBase,
                              checked: classes.switchChecked,
                              icon: classes.switchIcon,
                              iconChecked: classes.switchIconChecked,
                              bar: classes.switchBar
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="Automatically Order Meter"
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                      <br />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.isHighPriority}
                            onChange={this.handleSwitchTogle.bind(this, 'isHighPriority')}
                            classes={{
                              switchBase: classes.switchBase,
                              checked: classes.switchChecked,
                              icon: classes.switchIcon,
                              iconChecked: classes.switchIconChecked,
                              bar: classes.switchBar
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="High Priority Job"
                      />
                    </GridItem>


                    <GridItem xs={12} sm={6} md={3}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Job Class*
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.jobClass}
                          error={this.state.error.jobClass}
                          onChange={this.handleTextChange.bind(this, 'jobClass')}
                          inputProps={{
                            name: "jobClass",
                            id: "jobClass"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Project
                        </MenuItem>
                          {
                            ['SPU', 'LPU'].map((jobClass, index) =>
                              <MenuItem
                                key={index}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={jobClass}
                              >
                                {jobClass}
                              </MenuItem>
                            )
                          }

                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                      <CustomInput
                        labelText="Region"
                        id="region"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.region,
                          onChange: this.handleTextChange.bind(this, 'region'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                      <CustomInput
                        labelText="Municipality Reference Number"
                        id="municipalityRefNumber"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.municipalityRefNumber,
                          onChange: this.handleTextChange.bind(this, 'municipalityRefNumber'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={3}>
                      <CustomInput
                        labelText="Old Meter Number"
                        id="oldMeterNumber"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.oldMeterNumber,
                          onChange: this.handleTextChange.bind(this, 'oldMeterNumber'),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <br />
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        error={this.state.error.jobInstruction}
                        labelText="Job Instructions*"
                        id="jobInstruction"
                        formControlProps={{
                          fullWidth: true
                        }}
                        error={this.state.error.jobInstruction}
                        inputProps={{
                          type: "text",
                          multiline: true,
                          value: this.state.jobInstruction,
                          onChange: this.handleTextChange.bind(this, 'jobInstruction')
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={12} style={{ display: this.state.meterRequired ? '' : 'none' }}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Meter Filter Information</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={3}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Choose Meter Type
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          error={this.state.error.meterType}
                          value={this.state.meterType || ''}
                          onChange={this.handleTextChange.bind(this, 'meterType')}
                          inputProps={{
                            name: "meterType",
                            id: "meterType"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Meter Type
                        </MenuItem>
                          {
                            meterTypes.map((type, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                                key={index}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }

                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="meterPaymentType"
                        >
                          Choose Meter Payment Type
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.meterPaymentType || ''}
                          error={this.state.error.meterPaymentType}
                          onChange={this.handleTextChange.bind(this, 'meterPaymentType')}
                          inputProps={{
                            name: "meterPaymentType",
                            id: "meterPaymentType",
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Meter Payment Type
                        </MenuItem>
                          {
                            meterPaymentTypes.map((type, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                                key={index}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={3}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Meter Condition
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.condition || ''}
                          onChange={this.handleTextChange.bind(this, 'condition')}
                          inputProps={{
                            name: "condition",
                            id: "condition"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Meter Condition
                        </MenuItem>

                          {
                            meterConditions.map((type, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                                key={index}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={3}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="meterDialType"
                        >
                          Meter Dial Type
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.meterDialType || ''}
                          onChange={this.handleTextChange.bind(this, 'meterDialType')}
                          inputProps={{
                            name: "meterDialType",
                            id: "meterDialType"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Meter Dial Type
                        </MenuItem>
                          {
                            meterDialTypes.map((type, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                                key={index}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Brand"
                        id="brand"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.brand,
                          onChange: this.handleTextChange.bind(this, 'brand'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Model"
                        id="model"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.brand,
                          onChange: this.handleTextChange.bind(this, 'brand'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Tag"
                        id="tag"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.tag,
                          onChange: this.handleTextChange.bind(this, 'tag'),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <br />
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{marginLeft:"10px"}}>
                      <br />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.allowDuplicateJob}
                            onChange={this.toggleAllowDuplicateJob.bind(this)}
                            classes={{
                              switchBase: classes.switchBase,
                              checked: classes.switchChecked,
                              icon: classes.switchIcon,
                              iconChecked: classes.switchIconChecked,
                              bar: classes.switchBar
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="Allow Duplicate Job"
                      />
                    </GridItem>
        </GridContainer>
        <div style={{ textAlign: "center" }}>

          {
            this.props.jobsData.createLoader ?
              (<CircularProgress />) :
              (
                <Button color="info" onClick={this.createJobCard.bind(this)}>
                  <Add />
                  Create Job Card
            </Button>
              )
          }
        </div>
        <Snackbar
          place="tc"
          color="danger"
          message={this.props.jobsData.createErrors ? this.props.jobsData.createErrors.message : 'An unexpected error occured'}
          open={!!this.props.jobsData.createErrors}
          closeNotification={() => this.props.dispatch(createJobCardReset())}
          close
        />
        <Snackbar
          place="tc"
          color="success"
          message={'Successfully created the job card'}
          open={this.state.success}
          closeNotification={() => this.setState({ success: false })}
          close
        />
        {this.state.createdJob ? <SweetAlert
          success
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title="Job Created Successfully!"
          onConfirm={() => this.props.history.replace(`/admin/job/view/${this.state.createdJob.jobCardNumber}`)}
          
          onCancel={() => this.setState({createdJob:null})}
          confirmBtnStyle={successButtonStyle}
          cancelBtnStyle={dangerButtonStyle}
          confirmBtnText="Go to Job Card!"
          cancelBtnText="Close"
        >
          Job Number <b>{this.state.createdJob.jobCardNumber}</b>, Job Type <b>{this.state.createdJob.type}</b>,
        </SweetAlert>: ''}
      </div>
    );
  }
}

export default withStyles(extendedFormsStyle)(
  connect(state => ({
    configsData: state.appConfigState,
    projectData: state.projectState,
    jobsData: state.jobCardState,
  }))(CreateJobCard)
);
